import { useEffect, useState } from 'react';
import { analyticsApi } from '@/lib/api/arrex/analytics';
import { useApp } from '@/contexts/AppContext';
import { formatPrice } from '@/lib/format';
import { useTranslation } from 'react-i18next';
import { readItems } from '@/lib/api/normalize';
import { StatCardsSkeleton } from '@/components/ui/skeletons';

export default function AdminOverview() {
  const { t } = useTranslation();
  const { lang } = useApp();
  const [orders, setOrders] = useState<any[] | null>(null);

  useEffect(() => {
    analyticsApi.overview().then((res) => setOrders(readItems(res))).catch(() => setOrders([]));
  }, [lang]);

  if (!orders) {
    return (
      <div className="space-y-6">
        <h1 className="font-display text-3xl font-bold">{t('admin.overview.title')}</h1>
        <StatCardsSkeleton count={3} />
      </div>
    );
  }

  const revenue = orders
    .filter(o => ['pending', 'confirmed', 'processing', 'shipped', 'delivered'].includes(o.status))
    .reduce((s, o) => s + Number(o.total), 0);
  const pending = orders.filter(o => o.status === 'pending').length;

  const cards = [
    { label: t('admin.overview.sales'), value: formatPrice(revenue), accent: 'text-primary' },
    { label: t('admin.overview.orders'), value: orders.length, accent: '' },
    { label: t('admin.overview.pending'), value: pending, accent: 'text-destructive' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight">{t('admin.overview.title')}</h1>
        <p className="text-muted-foreground mt-1">{t('admin.overview.subtitle')}</p>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {cards.map(c => (
          <div key={c.label} className="rounded-lg border bg-card p-6">
            <p className="text-sm text-muted-foreground uppercase tracking-wider">{c.label}</p>
            <p className={`font-display text-3xl font-bold mt-2 ${c.accent}`}>{c.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
